// eslint-disable-next-line no-restricted-imports
import ReactSelect from 'react-select'
// eslint-disable-next-line no-restricted-imports
import StateManagedSelect from 'react-select'

import { DOM_IDS } from '@/lib/constants'

// A wrapper around react-select's default <Select /> component with some
// app-specific defaults. Use this in all places instead of react-select's
// default export
const Select: StateManagedSelect = (props) => {
  return (
    <ReactSelect
      menuPortalTarget={document.getElementById(DOM_IDS.reactSelectPortal)}
      menuPosition="fixed"
      {...props}
    />
  )
}

export default Select
